module.exports = __webpack_public_path__ + "static/media/left_triangle.38d46fdd.svg";